"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const settlementRequestDataState_1 = __importDefault(require("./settlementRequestDataState"));
const react_i18next_1 = require("react-i18next");
const react_hook_form_1 = require("react-hook-form");
const react_number_format_1 = __importDefault(require("react-number-format"));
const string_utils_1 = require("@/common/string_utils");
function default_1({ settlementRequestForm, settlementRequestType, }) {
    var _a, _b, _c;
    const [{ possible_amount, total_withdrawable_amount, total_reward_amount, room_status_cd_id }, setSettlementRequestData,] = (0, recoil_1.useRecoilState)(settlementRequestDataState_1.default);
    const isPaymentRequest = settlementRequestType === 'payment';
    const isWithdrawRequest = settlementRequestType === 'withdraw';
    const isBuyerInfoDiscarded = room_status_cd_id === 'ROOM_STATUS_06';
    const isRewardKeep = isWithdrawRequest &&
        possible_amount === 0 &&
        total_withdrawable_amount === 0 &&
        Boolean(total_reward_amount) &&
        isBuyerInfoDiscarded;
    const settlementableAmount = isRewardKeep ? total_reward_amount : possible_amount;
    const { control, formState: { errors }, setError, clearErrors, } = settlementRequestForm;
    const { t } = (0, react_i18next_1.useTranslation)();
    const { field: { ref, onChange, value }, } = (0, react_hook_form_1.useController)({
        name: 'request_amount',
        control,
        rules: {
            required: t(isPaymentRequest ? '제작비를 입력해주세요' : '정산 금액을 입력해주세요'),
            min: {
                value: isPaymentRequest ? 1000 : 1,
                message: t(isPaymentRequest ? '1,000원 이상 접수 가능해요' : '0원은 정산할 수 없어요'),
            },
        },
    });
    const onRequestAmountChange = (values) => {
        const inputNum = values.floatValue;
        if (inputNum) {
            clearErrors('root.request_amount');
        }
        if (inputNum && inputNum > settlementableAmount) {
            onChange('');
            setError('root.request_amount', { type: 'max', message: t('요청 가능액을 초과했어요') });
        }
        else
            onChange(inputNum);
    };
    const errorMessage = ((_b = (_a = errors === null || errors === void 0 ? void 0 : errors.root) === null || _a === void 0 ? void 0 : _a.request_amount) === null || _b === void 0 ? void 0 : _b.message) || ((_c = errors === null || errors === void 0 ? void 0 : errors.request_amount) === null || _c === void 0 ? void 0 : _c.message);
    const onRequestAmountInputBlur = (amount) => {
        setSettlementRequestData(prev => (Object.assign(Object.assign({}, prev), { request_amount: amount })));
    };
    (0, react_1.useEffect)(() => {
        if (isRewardKeep) {
            onChange(total_reward_amount);
            setSettlementRequestData(prev => (Object.assign(Object.assign({}, prev), { request_amount: total_reward_amount })));
        }
    }, [isRewardKeep]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "mobile-border-bottom-gray-5" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', alignItems: 'center', columnGap: '2px', padding: '16px 16px 10px' } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle3 gray-80" }, { children: t(isPaymentRequest ? '제작비' : '정산 금액') })), (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "caption1 gray-40" }, { children: ["(", t('최대 ₩')] })), (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "caption1 gray-40" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle5 gray-80" }, { children: (0, string_utils_1.money)(settlementableAmount) })), ")"] })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle3 error-main" }, { children: "*" }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '4px', padding: '0 16px 16px' } }, { children: [(0, jsx_runtime_1.jsx)(react_number_format_1.default, { disabled: isRewardKeep, className: "body1 gray-80", getInputRef: ref, value: value, onValueChange: onRequestAmountChange, onBlur: (e) => onRequestAmountInputBlur((0, string_utils_1.numberOnly)(e.target.value)), allowNegative: false, decimalScale: 0, thousandSeparator: true, autoComplete: "off", pattern: "\\d*", placeholder: "0", css: {
                            width: '100%',
                            height: '48px',
                            padding: '0 14px',
                            border: '1px solid var(--gray-10)',
                            borderRadius: '8px',
                        } }), errorMessage && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "caption1 error-main" }, { children: errorMessage }))] }))] })));
}
exports.default = default_1;
